import { Injectable } from '@angular/core';
import { TimeagoFormatter, TimeagoDefaultFormatter } from 'ngx-timeago';

@Injectable({
  providedIn: 'root',
})
export class CustomFormatter extends TimeagoDefaultFormatter implements TimeagoFormatter {
  override format(value: number): string {
    const timeNowInSeconds = Math.floor(Date.now() / 1000);
    const timestampInSeconds = Math.floor(value / 1000);
    const timeDifference = timeNowInSeconds - timestampInSeconds;

    if (timeDifference < 60) {
      return 'a few seconds ago';
    }

    return super.format(value);
  }
}
